
<table class="table table-hover oa-checkbox" (click)="onClick()" [title]="title">
  <tbody>
    <tr>
      <td class="table-cell checkbox-cell">
        @if (isChecked && !isDisabled) {
          <i class="fa-regular fa-check-square fa-xl" aria-hidden="true"></i>
        }
        @if (!isChecked && !isDisabled) {
          <i class="fa-regular fa-square fa-xl" aria-hidden="true"></i>
        }

        <!-- Couldn't get the fontawesome to show a disabled checkbox.  It's doable, but time crunch... -->
        @if (!isChecked && isDisabled) {
          <i class="fa-regular fa-square fa-xl text-muted" aria-hidden="true"></i>
        }
      </td>
      <td class="table-cell">
        <div [innerHTML]="label"></div>
      </td>
    </tr>
  </tbody>
</table>
